const Hero = (props) => {

  const {
    variant,
    preTitle,
    title,
    paragraph,
    ctaPrimary,
    ctaSecondary,
    image,
    colorScheme = 'darkGreen'
  } = props

  const normalizedData = {
    variant,
    pretitle: preTitle,
    title,
    paragraph,
    ctaPrimary,
    ctaSecondary,
    image: {
      alt: image.alt,
      src: image.url
    },
    colorScheme
  }

  return normalizedData
}

export default Hero
